import type { UserNoteEntityType } from './schema';

/** The same persisted resource is used by note writes, routes and cache keys. */
export const USER_NOTE_ENTITY_RESOURCES = {
  contact: 'contacts',
  company: 'companies',
  deal: 'deals',
  lead: 'leads',
  branch: 'branches',
} as const satisfies Record<UserNoteEntityType, string>;

export function userNoteEntityResource(entityType: UserNoteEntityType) {
  return USER_NOTE_ENTITY_RESOURCES[entityType];
}
